import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { AreaMap } from 'src/app/models/area-map.model';
import { AppAreaMapComponent } from './area-map.component';
import { AppFabricComponent } from './fabric.component';

@Component({
  selector: 'app-show-point-dialog',
  templateUrl: './show-point.dialog.html',
  styleUrls: ['./show-point.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
    AppAreaMapComponent,
    AppFabricComponent,
  ],
})
export class ShowPointDialogComponent {
  private _modal = inject(ModalController);
  private navParams = inject(NavParams);

  imageElementS = signal(this.navParams.get<HTMLImageElement>('imageElement'));
  pointS = signal(this.navParams.get<AreaMap>('point'));
  pointsS = signal(this.navParams.get<{ x: number; y: number; url: string }[]>('points'));

  dismiss() {
    this._modal.dismiss();
  }
}
